import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IJobCostEmployee extends IModel {
	jobCostKey?: string;
	changeOrderKey?: string;
	employeeKey?: string;
	role?: string;
}

const jobCostEmployeeFactory = modelFactory.createFactory<IJobCostEmployee>('JobCostEmployee', _.assign({}, model, {
	jobCostKey: {
		setFilters: valueFilters.clean
	},
	changeOrderKey: {
		setFilters: valueFilters.clean
	},
	employeeKey: {
		setFilters: valueFilters.clean,
		rules: validator.required()
	},
	role: {
		setFilters: valueFilters.clean,
		rules: validator.required()
	}
}));

export default jobCostEmployeeFactory;